import yup from '../../utils/yup';

export default yup.object().shape({
  email: yup.string().email().required()
});